import type { RoleCaseTask } from "@/components/Forms/SubForms/AssignTaskByRoleForm.tsx";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

type MutateProps = {
    tasksToCreate: RoleCaseTask[];
};
export const useAddCaseTaskByRole = (): UseMutationResult<void, Error, MutateProps> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (props: MutateProps) => {
            const body = {
                roleCaseTasks: props.tasksToCreate,
            };

            const response = await fetch(apiUrl("/case-task/add-by-role"), {
                method: "PUT",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify(body),
            });
            await handleJsonApiError(response);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["tasks"],
            });
            await queryClient.invalidateQueries({
                queryKey: ["case-tasks"],
            });
        },
    });
};
